'use client'

import { Checkbox } from '@graftcode/design-system'

import { WIZARD_COPY } from '../../const'
import type { QuickOptionsProps } from '../../types'

import styles from './QuickOptions.module.scss'

export function QuickOptions({
  graftableTypesOnly,
  graftableMethodsOnly,
  onGraftableTypesOnlyChange,
  onGraftableMethodsOnlyChange,
}: QuickOptionsProps) {
  const { quickOptions: copy } = WIZARD_COPY

  return (
    <section className={styles.quickOptions} aria-label={copy.ariaLabel}>
      <label className={styles.graftableToggle}>
        <Checkbox
          checked={graftableTypesOnly}
          disabled={graftableMethodsOnly}
          onChange={(checked) => onGraftableTypesOnlyChange(checked === true)}
        />
        <span className={styles.typeLabel}>
          <span>{copy.graftableTypes.label}</span>
          <span className={styles.graftableToggleHint}>
            {graftableMethodsOnly ? copy.graftableTypes.hintWhenMethodsOnly : copy.graftableTypes.hintDefault}
          </span>
        </span>
      </label>

      <label className={styles.graftableToggle}>
        <Checkbox
          checked={graftableMethodsOnly}
          onChange={(checked) => onGraftableMethodsOnlyChange(checked === true)}
        />
        <span className={styles.typeLabel}>
          <span>{copy.graftableMethods.label}</span>
          <span className={styles.graftableToggleHint}>{copy.graftableMethods.hint}</span>
        </span>
      </label>
    </section>
  )
}
